import React from 'react'
import { DashText } from 'legacy/dash-blocks/dash-text/DashText'
import { dashSpacing } from 'legacy/dash-blocks/foundation/spacing'

export interface DashLabelProps {
  label: string
  htmlFor: string
  id?: string
  className?: string
}

export const DashLabel = ({ htmlFor, label, id, className }: DashLabelProps) => (
  <label id={id} htmlFor={htmlFor} className={className} style={{ display: 'block' }}>
    <DashText
      weight="semibold"
      size="medium"
      color="darker-neutral"
      overrideStyle={{
        display: 'inline-block',
        marginBottom: dashSpacing.XXSMALL,
        lineHeight: '21px',
      }}
    >
      {label}
    </DashText>
  </label>
)
